import React from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import Icon from '../shared/Icon.tsx';
import {CodeIcon} from 'lucide-react';
import {MixModel, ProjectDataIndex} from '../../api/types.ts';
import AssistantVibeCoding from './AssistantVibeCoding.tsx';

interface VibeCodeModalProps {
    mix: MixModel;
    dataIndex: ProjectDataIndex;
    isOpen: boolean;
    mode: 'vibe' | 'edit';
    existingHtml?: string;
    // Opened on a remixed game: asks what to change, in plain words.
    askWhatToChange?: boolean;
    // A copy translating itself into this language (see AssistantVibeCoding).
    translateInto?: string | null;
    onClose: () => void;
    onDiscard?: () => void;
    onApplyHtml: (html: string) => void;
}

const VibeCodeModal: React.FC<VibeCodeModalProps> = ({
    mix,
    dataIndex,
    isOpen,
    mode,
    existingHtml,
    askWhatToChange,
    translateInto,
    onClose,
    onDiscard,
    onApplyHtml
}) => {
    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} fullscreen>
                <ModalHeader toggle={onClose}>
                    <span className="vibe-modal-header">
                        <span className="vibe-modal-header__icon">
                            <Icon icon={CodeIcon} />
                        </span>
                        <span>
                            <span className="vibe-modal-header__title">
                                {translateInto
                                    ? 'Your own copy'
                                    : askWhatToChange
                                    ? 'Change your copy'
                                    : mode === 'vibe'
                                    ? 'Vibe Coding Assistant'
                                    : 'Edit HTML Code'}
                            </span>
                            <span className="vibe-modal-header__subtitle">
                                {translateInto
                                    ? `Translating into ${translateInto}`
                                    : askWhatToChange
                                    ? 'Tell the AI what to change'
                                    : mode === 'vibe'
                                    ? 'Build a game or app with AI'
                                    : 'Modify your HTML with AI'}
                            </span>
                        </span>
                    </span>
                </ModalHeader>
                <AssistantVibeCoding
                    mix={mix}
                    dataIndex={dataIndex}
                    mode={mode}
                    existingHtml={existingHtml}
                    askWhatToChange={askWhatToChange}
                    translateInto={translateInto}
                    onApplyHtml={onApplyHtml}
                    onClose={onClose}
                    onDiscard={onDiscard}
                />
            </Modal>
        </>
    );
};

export default VibeCodeModal;
